import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiEdit3,
    title: "Blueprint Your Vision",
    description: "Define event titles, rich descriptions, and secure private URLs. Your event's identity is established in seconds with our rapid-entry interface."
  },
  {
    icon: FiIcons.FiMapPin,
    title: "Hybrid-Ready Infrastructure",
    description: "Seamlessly manage physical addresses or virtual access points. Pilot handles time zones and location mapping automatically for your guests."
  },
  {
    icon: FiIcons.FiCalendar,
    title: "Master the Clock",
    description: "Whether it's a 2-hour workshop or a 5-day summit, our multi-day scheduling engine keeps your sessions organized and on track."
  },
  {
    icon: FiIcons.FiTag,
    title: "Flexible Revenue Flows",
    description: "Deploy group packages or individual ticketing with ease. Set capacity limits, early-bird pricing, and custom access tiers instantly."
  },
  {
    icon: FiIcons.FiLayers,
    title: "Panoramic Oversight",
    description: "Toggle between Month, Week, and List views. See the big picture or dive into the details without ever losing your place."
  },
  {
    icon: FiIcons.FiRefreshCw,
    title: "Living Ecosystem",
    description: "Full bi-directional sync with Google Calendar. Changes made in Pilot reflect across your entire productivity suite in real-time."
  }
];

const PilotFeatures = () => {
  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-indigo-600 tracking-wide uppercase">The Pilot Advantage</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Total Command. Zero Friction.
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            We've distilled complex event logistics into a single, high-performance dashboard designed for modern organizers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative p-8 bg-slate-50 rounded-2xl hover:shadow-xl transition-all duration-300 border border-slate-100 group"
            >
              <div className="mb-6 inline-flex items-center justify-center p-3 bg-indigo-600 rounded-xl shadow-lg group-hover:scale-110 transition-transform">
                <SafeIcon icon={feature.icon} className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PilotFeatures;